import { shadesOf } from "@gymflow/helpers";
import { PropertiesSettingsDTO } from "@gymflow/types";
import hexToRgba from "hex-to-rgba";
import { useEffect } from "react";

import { resetTailwindColors } from "./resetTailwindColors";

function hexToTwRgba(hex: string) {
  const result = hexToRgba(hex);
  return result.replace("rgba(", "").replace(")", "");
}

function getShades(color: string) {
  const result = shadesOf(color) as any;
  for (const key in result) {
    result[key] = hexToTwRgba(result[key]);
  }
  return result;
}

function updateColorDefinition(
  shades: { [key: string]: string },
  colorName: string,
) {
  const root = document.querySelector(":root");
  const setProperty = (root as HTMLElement).style.setProperty.bind(
    (root as HTMLElement).style,
  );
  setProperty(`--${colorName}-color-950`, shades["950"]);
  setProperty(`--${colorName}-color-900`, shades["900"]);
  setProperty(`--${colorName}-color-800`, shades["800"]);
  setProperty(`--${colorName}-color-700`, shades["700"]);
  setProperty(`--${colorName}-color-600`, shades["600"]);
  setProperty(`--${colorName}-color-500`, shades["500"]);
  setProperty(`--${colorName}-color-400`, shades["400"]);
  setProperty(`--${colorName}-color-300`, shades["300"]);
  setProperty(`--${colorName}-color-200`, shades["200"]);
  setProperty(`--${colorName}-color-100`, shades["100"]);
  setProperty(`--${colorName}-color-50`, shades["50"]);
  setProperty(`--${colorName}-color-25`, shades["25"]);
  setProperty(`--${colorName}-color-0`, shades["0"]);
}

export const useCustomColors = (
  webSettings: PropertiesSettingsDTO["webSettings"] | undefined,
  enabled: boolean,
) => {
  useEffect(() => {
    if (!enabled) return;
    if (webSettings) {
      const root = document.querySelector(":root");
      if (root) {
        if (webSettings) {
          const primaryColor = webSettings.primaryColor;
          const grayShades = Object.keys(webSettings.grayShades ?? {}).reduce(
            (acc, key) => ({
              ...acc,
              [key]: hexToTwRgba(
                webSettings!.grayShades?.[
                  key as keyof typeof webSettings.grayShades
                ],
              ),
            }),
            {},
          );
          const primaryShades = getShades(primaryColor);
          updateColorDefinition(primaryShades, "primary");
          updateColorDefinition(primaryShades, "secondary");
          updateColorDefinition(grayShades, "gray");
          const setProperty = (root as HTMLElement).style.setProperty.bind(
            (root as HTMLElement).style,
          );

          setProperty("--ring-color", primaryShades["500"]);
        } else {
          resetTailwindColors();
        }
      }
    }
  }, [enabled, webSettings]);
};
